export default __webpack_public_path__ + "static/highlight-db022e2743e00b1ad84dd9fd549e2d61.png";